<template>
  <v-container grid-list-md fluid>
    <v-layout
      row
      wrap
      flat
      style="z-index: 3"
      class="white shadow justify-center align-center px-3 py-2"
    >
      <v-autocomplete
        outline
        singleLine
        hideDetails
        class="mx-1"
        autocomplete
        item-value="id"
        item-text="name"
        @change="initData"
        v-model="branch_id"
        :items="branch_filters"
        style="max-width: 300px"
        :placeholder="$t('branch')"
        v-if="userCan('view_all_branches_report')"
      />
      <v-spacer class="hidden-sm-and-down" />
      <v-date
        singleLine
        :hideDetails="true"
        @input="initData"
        :clearable="false"
        :disabled="loading"
        v-model="start_date"
        format="YYYY-MM-DD"
        value-type="YYYY-MM-DD"
        style="max-width: 350px"
        class="mx-1 hide-details"
        input_id="start_date_expo_dd"
        :placeholder="$t('start_date')"
      />
      <v-date
        singleLine
        :hideDetails="true"
        @input="initData"
        :clearable="false"
        v-model="end_date"
        :disabled="loading"
        format="YYYY-MM-DD"
        value-type="YYYY-MM-DD"
        style="max-width: 350px"
        class="mx-1 hide-details"
        input_id="start_date_expo_end"
        :placeholder="$t('end_date')"
      />
      <v-btn
        icon
        flat
        medium
        @click="initData"
        :loading="loading"
        color="grey darken-2"
      >
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <income-statement-table
          :title="title"
          :rates="mapped_rates"
          :currencies="currencies"
          :customers="all_accounts"
          :brnch_name="selectedBranch.name"
        />

        <!-- <customer-accounts
          :external="true"
          :currencies="currencies"
          :customers="stock"
          :title="$t('stock')"
        />-->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { customersMixin } from "@/mixins/index.js";
import incomeStatementTable from "./incomeStatementTable.vue";

let currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 30);

export default {
  name: "income-statment",
  components: { incomeStatementTable },
  mixins: [customersMixin],
  data: () => ({
    rates: [],
    system: [],
    branches: [],
    incomes: [],
    expenses: [],
    loading: false,
    all_accounts: [],
    old_balance: 0,
    corporates: [],
    individuals: [],
    DailyProfit: [],
    mapped_rates: {},
    shareholders: [],
    daily_changes: [],
    stock: [],
    branch_id: "",
    branch_filters: [],
    start_date: currentDate.toLocaleDateString("en-ca"),
    end_date: new Date().toLocaleDateString("en-ca"),
  }),

  computed: {
    currencies() {
      return this.initialData.currencies;
    },
    title() {
      return `${this.$t('income_statement_from')} ( ${
        this.start_date
      } ${this.persianDateFilter(this.start_date, true)} ) ${this.$t('to')} ( ${
        this.end_date
      } ${this.persianDateFilter(this.end_date, true)} )`
    },
    selectedBranch: (vm) =>
      vm.branch_filters.find((x) => x.id == vm.branch_id) || {},
  },

  methods: {
    async ratesUpdated() {
      await this.initData();
      // this.$refs.summery.save();
    },

    getBranches() {
      this.axios.get("branches").then((res) => {
        this.branch_filters = res.data;
      });
    },

    async initData() {
      this.loading = true;
      await this.axios
        .get(
          `reports?company_report=true&start_date=${this.start_date}&end_date=${this.end_date}&branch_id=${this.branch_id}`
        )
        .then((res) => {
          this.rates = res.data.rates;
          this.mapped_rates = res.data.mapped_rates;
          this.daily_changes = res.data.daily_changes;
          let accounts = Object.keys(res.data.accounts).map(
            (k) => res.data.accounts[k]
          );
          this.all_accounts = accounts.filter(
            (x) => x.type == "income" || x.type == "expense"
          );
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  created() {
    this.branch_id = this.userBranch.id;
    this.getBranches();
    this.initData();
    this.getCustomers();
  },
};
</script>
